/**
 * The one freshness number the corpus pipeline agrees on, shared by both
 * sides so they can't drift:
 *
 * - The client caches corpus queries with `staleTime: CORPUS_STALE_TIME_MS`
 *   (CORPUS_QUERY_OPTIONS) — the UI treats corpus data this old as current.
 * - The server response cache uses the same number as its soft TTL
 *   (corpusResponseCache.ts): within it a cached response is served as fresh,
 *   past it stale-while-revalidate kicks in.
 *
 * The server cache's freshness model is DERIVED from the client's tolerance —
 * change this and both move together, which is the point.
 */
export const CORPUS_STALE_TIME_MS = 60_000;
